var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIconPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#F05978;enable-background:new    ;}\n\t.st1{fill:#F05978;}\n\t.st2{opacity:0.8;fill:#F05978;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_x2F_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M1.6,19c-1.3,0-2.6-0.2-3.9-0.7c-2.1-0.8-1.7-2-1.4-2.5c0-0.1,0.7-1.2,1.6-2.8 c0.2,0.2,0.4,0.4,0.6,0.5c0.4,0.3,1,0.8,1.6,0.8c0.4,0,0.8-0.2,1.1-0.6c0,0,4.5-8.1,6.9-12.5c3.6,3.4,4.7,8.6,2.4,12.7 C8.8,17,5.3,19,1.6,19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st1",
    d: "M0.1,14.2c-0.6,0-1.3-0.4-1.6-0.8c-0.2-0.2-0.4-0.4-0.6-0.5C0.3,8.5,4.8,0.4,4.8,0.4 c0.3-0.4,0.7-0.6,1.1-0.6c0.6,0,1.3,0.4,1.6,0.8c0.2,0.2,0.4,0.4,0.6,0.5C5.7,5.5,1.2,13.6,1.2,13.6C0.9,14.1,0.5,14.2,0.1,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st2",
    d: "M-2.1,12.9C-5.7,9.5-6.8,4.3-4.6,0.2C-2.8-3,0.7-5,4.4-5C5.7-5,7-4.8,8.2-4.3 c2.1,0.8,1.7,2,1.4,2.5c0,0.1-0.7,1.2-1.6,2.8C7.9,0.9,7.7,0.7,7.5,0.6c-0.4-0.3-1-0.8-1.6-0.8c-0.4,0-0.8,0.2-1.1,0.6 C4.8,0.4,0.3,8.5-2.1,12.9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconPink);
export default __webpack_public_path__ + "static/media/logo-icon-pink.3859bc2fc8d10de204f9bd67399ebc5c.svg";
export { ForwardRef as ReactComponent };